module.exports = __webpack_public_path__ + "static/media/content-thoi-trang-1.9a82058f.jpg";